import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';

@Component({
    selector: 'fe-insurance-info-modal',
    templateUrl: './insurance-info-modal.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InsuranceInfoModalComponent {
    @ViewChild('swal') private readonly swal!: SwalComponent;

    public fire(): void {
        this.swal.fire();
    }
}
